module.exports = __webpack_public_path__ + "static/media/gd.6219a1ca.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/gd.svg
// module id = 2095
// module chunks = 0